/** Dispatched after a project is updated outside list hooks (e.g. quota archive). */
export const PROJECT_UPDATED_EVENT = 'leadsme:project-updated';
